import styled, { css } from 'styled-components';
// import cssKit from '../../css';

const helios = process.env.VENDOR === 'helios';
const nissan = process.env.BRAND_NAME === 'nissan';

export const StyledCTAButton = styled.a`
  width:100%;
  border:${nissan ? 'none' : '1px solid #000000 !important'};
  /* border: none !important; */

  ${helios && css`
    text-align: left;

    &:after {
      position: relative;
      content: '';
      width: .45rem;
      height: .45rem;
      display: inline-block;
      background: 0 0;
      border-top: solid 2px #fff;
      border-left: solid 2px #fff;
      -webkit-transform: rotate(45deg) translate(-50%);
      -ms-transform: rotate(45deg) translate(-50%);
      transform: rotate(135deg) translate(-50%);
      pointer-events: none;
      left: 0;
      top: 5px;
      padding: 0;
      margin: 0;
      float: right;
    }
  `}

  ${helios && !nissan && css`
    .secondary::after {
      border-top: solid 2px #000;
      border-left: solid 2px #000;
    }

    .secondary:hover::after {
      border-top: solid 2px #fff;
      border-left: solid 2px #fff;
    }

    &:hover::after {
      border-top: solid 2px #000;
      border-left: solid 2px #000;
    }

  `}
`;



/** WEBPACK FOOTER **
 ** ./src/components/CTAButton/styles.js
 **/